import React from 'react';

const ShoppingOnlineProcedures = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Procedure for Shopping Online Products on Xgo Life App</h1>
      <p className="mb-4">
        By following these steps, you can ensure a smooth and efficient online shopping experience with the Xgo Life App.
      </p>

      <h2 className="text-2xl font-semibold mt-6">1. Account Creation and Login</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Download the App:</strong> Install the Xgo Life App from the App Store or Google Play.</li>
        <li><strong>Create an Account:</strong> Sign up by providing your email address, creating a password, and entering any required personal information.</li>
        <li><strong>Login:</strong> Use your credentials to log into the app.</li>
      </ul>

      <h2 className="text-2xl font-semibold">2. Browsing Products</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Explore Categories:</strong> Navigate through the product categories or use the search bar to find specific items.</li>
        <li><strong>Product Filters:</strong> Use filters to narrow down your search based on criteria such as price, brand, or ratings.</li>
      </ul>

      <h2 className="text-2xl font-semibold">3. Product Details</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Select a Product:</strong> Click on the product to view detailed information, including descriptions, specifications, and customer reviews.</li>
        <li><strong>Check Availability:</strong> Ensure the item is in stock and check for any size or color options.</li>
      </ul>

      <h2 className="text-2xl font-semibold">4. Adding to Cart</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Select Options:</strong> Choose any necessary options (like size or color) before adding the product to your cart.</li>
        <li><strong>Add to Cart:</strong> Click the "Add to Cart" button to save the item for later purchase. You can continue shopping or proceed to checkout.</li>
      </ul>

      <h2 className="text-2xl font-semibold">5. Reviewing Your Cart</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>View Cart:</strong> Access your cart to review the selected items, quantities, and total cost.</li>
        <li><strong>Edit Cart:</strong> Modify quantities or remove items as needed. Ensure all items are correct before proceeding.</li>
      </ul>

      <h2 className="text-2xl font-semibold">6. Checkout Process</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Proceed to Checkout:</strong> Click the "Checkout" button to begin the payment process.</li>
        <li><strong>Enter Shipping Information:</strong> Provide or confirm your shipping address. Ensure accuracy to avoid delivery issues.</li>
      </ul>

      <h2 className="text-2xl font-semibold">7. Payment Options</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Select Payment Method:</strong> Choose your preferred payment method (credit/debit card, digital wallet, etc.).</li>
        <li><strong>Enter Payment Details:</strong> Input your payment information securely. Review to ensure accuracy.</li>
      </ul>

      <h2 className="text-2xl font-semibold">8. Review Order</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Order Summary:</strong> Check the final order summary, including items, shipping costs, and estimated delivery dates.</li>
        <li><strong>Apply Discounts:</strong> If applicable, enter any promo codes or discounts before finalizing the purchase.</li>
      </ul>

      <h2 className="text-2xl font-semibold">9. Place Order</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Confirm Purchase:</strong> Click "Place Order" to complete your transaction. You should receive an order confirmation via email or in-app notification.</li>
        <li><strong>Save Confirmation:</strong> Keep a record of your order confirmation number for future reference.</li>
      </ul>

      <h2 className="text-2xl font-semibold">10. Tracking Your Order</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Order Status:</strong> Use the app to track the status of your order. Updates may include processing, shipped, and out for delivery.</li>
        <li><strong>Notifications:</strong> Enable notifications to receive updates on your order status.</li>
      </ul>

      <h2 className="text-2xl font-semibold">11. Receiving Your Order</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Delivery Confirmation:</strong> Ensure you are available to receive the package upon delivery. Check for any delivery instructions provided.</li>
        <li><strong>Inspect Items:</strong> Upon receipt, inspect the items for accuracy and damage. Report any issues promptly.</li>
      </ul>

      <h2 className="text-2xl font-semibold">12. Returns and Exchanges</h2>
      <ul className="list-disc ml-6 mb-4">
        <li><strong>Return Policy:</strong> Familiarize yourself with the return policy for the Xgo Life App regarding timelines and acceptable conditions for returns.</li>
        <li><strong>Initiate Return:</strong> If necessary, follow the app’s procedure to initiate a return or exchange, providing order details and reasons for the return.</li>
      </ul>
    </div>
  );
};

export default ShoppingOnlineProcedures;